/**
 * Given a user class, check if it has the privileges to do something.
 *
 * See `packages/shared/enums/UserClass.ts` for the list of user classes.
 */

import UserClass from '@pkgs/shared/enums/UserClass';

const PRIVILEGE_TO_CLASSES_MAP = {
	[UserClass.BETA]: [UserClass.BETA, UserClass.MODERATOR, UserClass.CURATOR, UserClass.INSPO],
	[UserClass.MODERATOR]: [UserClass.MODERATOR, UserClass.CURATOR, UserClass.INSPO],
	[UserClass.CURATOR]: [UserClass.CURATOR],
	[UserClass.INSPO]: [UserClass.INSPO],
};

export default function userClassHasUserClassPrivileges(
	userClass: ValueOf<typeof UserClass> | null | undefined,
	userClassToCheck: ValueOf<typeof UserClass>,
): boolean {
	if (userClass) {
		return PRIVILEGE_TO_CLASSES_MAP[userClassToCheck].some((c) => c.includes(userClass));
	}

	return false;
}
